import { render, staticRenderFns } from "./ErrorSnackBar.vue?vue&type=template&id=827ed690&scoped=true&"
import script from "./ErrorSnackBar.vue?vue&type=script&lang=js&"
export * from "./ErrorSnackBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827ed690",
  null
  
)

export default component.exports